import { clsx } from "clsx";
import styles from "./Section.module.scss";

export function Section({ children }: { children: React.ReactNode }) {
  return <div className={clsx("vst-card", styles.section)}>{children}</div>;
}
